import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewChild,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownType } from '../../../shared/enums/dropdown-type.enums';
import { ButtonComponent } from '../../molecules/button/button.component';
import { ButtonType } from '../../../shared/enums/button-type.enums';
import { IconComponent } from '../../atoms/icon/icon.component';

import { Colors } from '../../../shared/enums/shared.enums';
import { Link } from '../../../shared/interfaces/link.interface';

import { Router } from '@angular/router';
import { HrefType } from '../../../shared/enums/href-type.enums';
import LinkType from '../../../shared/enums/link-type.enums';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-dropdown',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent, CapitalizePipe],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class DropdownComponent implements OnInit {
  @ViewChild('combobox') input: ElementRef<HTMLInputElement> | undefined;
  @Input() isOpen: boolean = false;
  @Input() icon = 'chevron-up';
  @Input() iconButton = 'chevron-down';
  @Input() type: DropdownType = DropdownType.DEFAULT;
  @Input() items: Link[] = [];
  @Input() bgColor: Colors = Colors.GREEN;
  @Input() linkType: LinkType = LinkType.DEFAULT;
  @Input() itemList: Array<string> = [];
  @Input() dropdownHeader: string = 'Dropdown';
  @Input() dropdownPlaceholder: string = 'Bitte auswählen';
  @Output() clickEvent: EventEmitter<string> = new EventEmitter<string>();

  activeItemList: string = '';
  activeItem: Link = {
    label: '',
    href: '',
    hrefType: HrefType.ANGULAR_ROUTE,
  };
  dropdownPlaceholderDefault: string = this.dropdownPlaceholder;
  dropdown: ButtonType = ButtonType.SECONDARY_ICON;

  public readonly Colors = Colors;
  public readonly HrefType = HrefType;

  constructor(
    private readonly router: Router,
    private readonly renderer: Renderer2,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.itemList = [this.dropdownPlaceholder, ...this.itemList];
    this.activeItemList = this.itemList[0];
    this.dropdownPlaceholderDefault = this.dropdownPlaceholder;
    this.cdRef.detectChanges();
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectItemList(idx: number) {
    this.activeItemList = this.itemList[idx];
    this.dropdownPlaceholder = this.activeItemList;
    this.isOpen = false;
    this.clickEvent.emit(this.activeItemList);
  }

  selectItem(idx: number) {
    this.activeItem = this.items[idx];
    this.isOpen = false;
    this.clickEvent.emit(this.activeItem.label);
  }
}
